import StandardGateway from 'scripts/adapters/gateways/lib/standard_gateway';

export default class TeamsHttpGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/teams/:id');
  }

  addOrReplace(params, data) {
    let url = this.endpoint.set(params).replaceUrl;
    let resource = this.endpoint.patterns.replaceUrl;
    return this.http
      .put(url, data || params, undefined, resource)
      .then(dto => {
        this.observer.onReplaceSuccess(dto, params);
        return dto;
      })
      .catch(error => {
        this.observer.onReplaceError(error, params);
        throw error;
      });
  }
}
